import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ApiObjectData } from '../models/api-object-data';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BaseService {
    appUrl = environment.baseUrl + '/';
    apiUrl = environment.baseUrl + '/api/';
    imgUrl = environment.baseUrl
    ticketsUrl = environment.ticketsUrl
    private logoutTimer: any;
    private currentUser: any; // Property to store user data

    constructor(
        public http: HttpClient,
        public router: Router,
        public translate: TranslateService,
    ) { }

    get(id: number, controller: string): Observable<ApiObjectData> {
        return this.http.get<ApiObjectData>(this.apiUrl + controller + '/' + id);
    }

    getById<T>(controller: string, params?: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';
        const encryptedTeamIds = localStorage.getItem('encryptedTeamIds') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang,
            'EncryptedTeamIds': encryptedTeamIds
        });

        const options = {
            headers: headers,
            params: params || {}
        };

        return this.http.get<T>(`${this.apiUrl}${controller}`, options);
    }

    heskMethod<T>(controller: string, body: any): Observable<T> {
        let headers = new HttpHeaders();
        const isFormData = body instanceof FormData;

        if (!isFormData) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.http.post<T>(controller, body, isFormData ? {} : { headers });
    }

    searchByFilters(startDate?: string, endDate?: string, isActive?: boolean): Observable<ApiObjectData> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
        });

        let httpParams = new HttpParams();
        if (startDate) httpParams = httpParams.set('startDate', startDate);
        if (endDate) httpParams = httpParams.set('endDate', endDate);
        if (isActive !== undefined) httpParams = httpParams.set('isActive', isActive.toString());

        const options = {
            headers: headers,
            params: httpParams
        };


        return this.http.post<ApiObjectData>(`${this.apiUrl}services/app/Project/SearchProjectsByFilters`, {}, options);
    }




    gets<T>(controller: string): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';
        const encryptedTeamIds = localStorage.getItem('encryptedTeamIds') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang,
            'EncryptedTeamIds': encryptedTeamIds
        });
        const options = {
            headers: headers,
        };

        return this.http.get<T>(`${this.apiUrl}${controller}/`, options);
    }

    save<T>(controller: string, model: any, headers?: HttpHeaders): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const defaultHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers || defaultHeaders,
        };

        return this.http.post<T>(`${this.apiUrl}${controller}/`, model, options);
    }

    updateWithPut<T>(controller: string, model: any, headers?: HttpHeaders): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const defaultHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers || defaultHeaders,
        };

        return this.http.put<T>(`${this.apiUrl}${controller}/`, model, options);
    }

    updateProcessActivation<T>(controller: string, processID: number, isActive: boolean, headers?: HttpHeaders): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const defaultHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers || defaultHeaders,
        };

        const url = `${this.apiUrl}${controller}?ProcessID=${processID}&isActive=${isActive}`;

        return this.http.put<T>(url, {}, options);
    }

    UpdateUserLoginTime<T>(controller: string, userId: number, headers?: HttpHeaders): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const defaultHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers || defaultHeaders,
        };

        const url = `${this.apiUrl}${controller}?userId=${userId}`;

        return this.http.put<T>(url, {}, options);
    }

    updateEmployeeIsOut<T>(controller: string, empId: number, headers?: HttpHeaders): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const defaultHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers || defaultHeaders,
        };

        const url = `${this.apiUrl}${controller}?empId=${empId}`;

        return this.http.put<T>(url, {}, options);
    }

    upload<T>(controller: string, formData: FormData, headers?: HttpHeaders): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';
        const defaultHeaders = new HttpHeaders({
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers || defaultHeaders
        };

        return this.http.post<T>(`${this.apiUrl}${controller}`, formData, options);
    }

    update<T>(controller: string, model: any, headers?: HttpHeaders): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const defaultHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers || defaultHeaders,
        };

        return this.http.put<T>(`${this.apiUrl}${controller}/`, model, options);
    }

    saveByParam<T>(controller: string, email: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
        };

        const url = `${this.apiUrl}${controller}?email=${encodeURIComponent(email)}`;
        return this.http.post<T>(url, null, { headers })
    }

    saveByParamPhone<T>(controller: string, phoneNumber: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
        };

        const url = `${this.apiUrl}${controller}?phoneNumber=${phoneNumber}`;
        return this.http.post<T>(url, null, { headers })
    }

    saveByParamParentId<T>(controller: string, parentId: any, childId: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
        };

        const url = `${this.apiUrl}${controller}?parentId=${parentId}&childId=${childId}`;
        return this.http.post<T>(url, null, { headers })
    }

    saveById<T>(controller: string, id: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
        };

        const url = `${this.apiUrl}${controller}?id=${id}`;
        return this.http.post<T>(url, null, { headers })
    }

    assignById<T>(controller: string, empId: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
        };

        const url = `${this.apiUrl}${controller}?empId=${empId}`;
        return this.http.post<T>(url, null, { headers })
    }

    checkEmp<T>(controller: string, jobNumber: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
        };

        const url = `${this.apiUrl}${controller}?jobNumber=${jobNumber}`;
        return this.http.post<T>(url, null, { headers })
    }

    checkResidance<T>(controller: string, residentNo: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
        };

        const url = `${this.apiUrl}${controller}?residentNo=${residentNo}`;
        return this.http.post<T>(url, null, { headers })
    }

    checkPassport<T>(controller: string, passportNo: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
        };

        const url = `${this.apiUrl}${controller}?passportNo=${passportNo}`;
        return this.http.post<T>(url, null, { headers })
    }

    assignByIdForVac<T>(controller: string, empId: any, isOnVacation: boolean): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
        };

        const url = `${this.apiUrl}${controller}?empId=${empId}&isOnVacation=${isOnVacation}`;
        return this.http.post<T>(url, null, { headers })
    }

    verfityTheOtp<T>(controller: string, params: { [key: string]: string | number }): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
        };

        let queryString = Object.keys(params).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&');
        const url = `${this.apiUrl}${controller}?${queryString}`;
        return this.http.post<T>(url, null, { headers })
    }

    deleteById<T>(controller: string, id: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
            params: new HttpParams().set('id', id)
        };

        return this.http.delete<T>(`${this.apiUrl}${controller}`, options);
    }

    deleteByUserId<T>(controller: string, id: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
            params: new HttpParams().set('Id', id)
        };

        return this.http.delete<T>(`${this.apiUrl}${controller}`, options);
    }

    deleteByRoleId<T>(controller: string, RoleID: number): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
            params: new HttpParams().set('RoleID', RoleID)
        };

        return this.http.delete<T>(`${this.apiUrl}${controller}`, options);
    }

    deleteByshiftId<T>(controller: string, shiftId: number): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
            params: new HttpParams().set('shiftId', shiftId)
        };

        return this.http.delete<T>(`${this.apiUrl}${controller}`, options);
    }

    deleteByunitId<T>(controller: string, unitId: number): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
            params: new HttpParams().set('unitId', unitId)
        };

        return this.http.delete<T>(`${this.apiUrl}${controller}`, options);
    }

    deleteProcessById<T>(controller: string, ProcessID: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
            params: new HttpParams().set('ProcessID', ProcessID)
        };

        return this.http.delete<T>(`${this.apiUrl}${controller}`, options);
    }

    deleteProcessApprovalById<T>(controller: string, ProcessApprovalID: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
            params: new HttpParams().set('ProcessApprovalID', ProcessApprovalID)
        };

        return this.http.delete<T>(`${this.apiUrl}${controller}`, options);
    }

    deleteProcessProcessApprovalUserID<T>(controller: string, ProcessApprovalUserID: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
            params: new HttpParams().set('ProcessApprovalUserID', ProcessApprovalUserID)
        };

        return this.http.delete<T>(`${this.apiUrl}${controller}`, options);
    }

    deleteByEmpId<T>(controller: string, EmpId: any, ShiftId: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
            params: new HttpParams()
                .set('EmpId', EmpId)
                .set('ShiftId', ShiftId)
        };

        return this.http.delete<T>(`${this.apiUrl}${controller}`, options);
    }

    deleteByEmpIdAndTeamId<T>(controller: string, empId: any, teamId: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
            params: new HttpParams()
                .set('empId', empId)
                .set('teamId', teamId)
        };

        return this.http.delete<T>(`${this.apiUrl}${controller}`, options);
    }


    Assign<T>(controller: string, empId: any, shiftId: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
        };

        const url = `${this.apiUrl}${controller}?empId=${empId}&shiftId=${shiftId}`;
        return this.http.post<T>(url, null, { headers })
    }

    AdminRole<T>(controller: string, UserId: any, CompanyId: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
        };

        const url = `${this.apiUrl}${controller}?UserId=${UserId}&CompanyId=${CompanyId}`;
        return this.http.post<T>(url, null, { headers })
    }

    Renew<T>(controller: string, empId: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
        };

        const url = `${this.apiUrl}${controller}?empId=${empId}`;
        return this.http.post<T>(url, null, { headers })
    }

    reset<T>(controller: string, userId: any): Observable<T> {
        const token = localStorage.getItem('accessToken');
        const lang = localStorage.getItem('lang') || '';

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'Accept-Language': lang
        });

        const options = {
            headers: headers,
        };

        const url = `${this.apiUrl}${controller}?userId=${userId}`;
        return this.http.post<T>(url, null, { headers })
    }

    saveBatch(controller: string, model: any) {
        return this.http.post(this.apiUrl + controller + '/', model);
    }

    remove(controller: string, id: number) {
        return this.http.delete(this.apiUrl + controller + id);
    }

    posts(controller: string, id: number) {
        return this.http.post(this.apiUrl + controller + id, '');
    }

    Remove(controller: string, id: number) {
        return this.http.delete(this.apiUrl + controller + '/Remove/' + id);
    }
    Removes(controller: string, id: number, excId: number, userId: number) {
        return this.http.delete(this.apiUrl + controller + id + '/' + excId + '/' + userId);
    }

    delete(controller: string, id: number) {
        return this.http.delete(this.apiUrl + controller + '/delete/' + id);
    }

    removes(controller: string, id: number) {
        return this.http.delete(this.apiUrl + controller + id)
    }

    post(controller: string, operation: string, model: any) {
        return this.http.post(this.apiUrl + controller + '/' + operation, model);
    }

    deletePost(controller: string, id: any) {
        return this.http.post(this.apiUrl + controller + '/' + id, {});
    }

    filePath(controller: string, filepath: string) {
        const url = `${this.apiUrl}${controller}?filePath=${encodeURIComponent(filepath)}`;
        return this.http.post(url, {});
    }

    Put(controller: string, model: any) {
        return this.http.put(this.apiUrl + controller, model)
    }

    PutMain(controller: string, id: any, model: any) {
        return this.http.put(this.apiUrl + controller + '/' + id, model);
    }

    Putmini(controller: string, id: any, userId: any) {
        return this.http.put(this.apiUrl + controller + '/' + id + '/' + userId, {});
    }

    PutPlus(controller: string, id: any, userId: any, buildingId: any) {
        return this.http.put(this.apiUrl + controller + '/' + id + '/' + userId + '/' + buildingId, {});
    }

    PutwithId(controller: string, userId: any) {
        return this.http.put(this.apiUrl + controller + '/' + userId, {});
    }

    // Method to set current user data
    setCurrentUser(user: any): void {
        this.currentUser = user;
        localStorage.setItem('currentUser', JSON.stringify(user)); // Store user in localStorage

        if (user !== null) {
            const expirationTime = new Date().getTime() + user.expireInSeconds * 1000;
            localStorage.setItem('expirationTime', expirationTime.toString());
            this.setLogoutTimer(user.expireInSeconds);
        }

    }

    setLogoutTimer(duration: number) {
        // Clear any existing timer
        if (this.logoutTimer) {
            clearTimeout(this.logoutTimer);
        }

        // Set a new timer
        this.logoutTimer = setTimeout(() => {
            this.autoLogout();
        }, duration * 1000); // Convert seconds to milliseconds
    }


    autoLogout() {
        // Clear the token and any user-related data
        localStorage.removeItem('currentUser');
        localStorage.removeItem('expirationTime');

        // Redirect to the login page
        this.router.navigate(['/auth/login']);

        // Clear the timer
        if (this.logoutTimer) {
            clearTimeout(this.logoutTimer);
        }
    }


    // Method to get current user data
    getCurrentUser(): any {
        if (!this.currentUser) {
            const user = localStorage.getItem('currentUser');
            this.currentUser = user ? JSON.parse(user) : null;
        }

        return this.currentUser;
    }
}